import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type InitialState = {
    leftSidebar: {
        isOpen: boolean;
        instance: "addElement" | "editElement" | "actions" | "assistant";
    };
    rightSidebar: {
        instance: "structure" | "storeData" | "settings";
    };
};

const initialState: InitialState = {
    leftSidebar: {
        isOpen: true,
        instance: "addElement"
    },
    rightSidebar: {
        instance: "structure"
    }
};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState: initialState,
    reducers: {
        openLeftSidebar: state => {
            return {
                ...state,
                leftSidebar: {
                    ...state.leftSidebar,
                    isOpen: true
                }
            };
        },
        closeLeftSidebar: state => {
            return {
                ...state,
                leftSidebar: {
                    ...state.leftSidebar,
                    isOpen: false
                }
            };
        },
        setLeftInstance: (state, action: PayloadAction<"addElement" | "editElement" | "actions" | "assistant">) => {
            return {
                ...state,
                leftSidebar: {
                    ...state.leftSidebar,
                    instance: action.payload
                }
            };
        },
        setRightInstance: (state, action: PayloadAction<"structure" | "storeData" | "settings">) => {
            return {
                ...state,
                rightSidebar: {
                    ...state.rightSidebar,
                    instance: action.payload
                }
            };
        }
    }
});

export default sidebarSlice.reducer;
export const { openLeftSidebar, closeLeftSidebar, setLeftInstance, setRightInstance } = sidebarSlice.actions;
